module.exports = __webpack_public_path__ + "fonts/ProximaNovaAExCn-Black.d9b080ea24a67067727485b07f35848c.eot";